import React, { useState } from "react";
import { Snackbar } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import { makeStyles } from "@material-ui/core/styles";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
}));

export default (props) => {
  const { deliverCost } = props;
  const classes = useStyles();
  const [open, setOpen] = useState(true);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  let DistanceAlert;
  switch (props.distanceState.status) {
    case "OK":
      DistanceAlert = deliverCost.isFree ? (
        <Alert severity="success" onClose={handleClose}>
          Sie bekommen kostenlos lieferung!
        </Alert>
      ) : (
        <Alert severity="warning" onClose={handleClose}>
          Ihre Lieferkosten beträgt {deliverCost.cost} Euro. Ihre eingegebene
          Adresse ist {props.distanceState.customerAddress} (
          {deliverCost.distance}km entfernt).
        </Alert>
      );
      break;
    case "NOT_FOUND":
      DistanceAlert = (
        <Alert severity="error" onClose={handleClose}>
          Google Maps kann nicht Ihre eingegebene Adresse finden. Bitte
          korrigieren Sie sich, oder rufen Sie uns an. Ihre eingegebene Adresse
          ist {props.distanceState.customerAddress}.
        </Alert>
      );
      break;
    default:
      DistanceAlert = (
        <Alert severity="error" onClose={handleClose}>
          Fehler. Bitte akktulieren Sie diese Seite.
        </Alert>
      );
      break;
  }

  return (
    <div className={classes.root}>
      <Snackbar
        open={open}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        onClose={handleClose}
      >
        {DistanceAlert}
      </Snackbar>
    </div>
  );
};
